// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1RKeQ","footer":"ReportModalFilter_footer__NWkuW"};